// Mirrors SurveyReportType / SurveyReportStatus in investcore/src/model.
export const SURVEY_REPORT_TYPE = {
  GENERAL: 1001,
  INVESTMENT_HEALTHCHECK: 1002,
  HOT_NEW: 1003,
  SETUP_RISK_PROFILE: 1004,
};

export const surveyReportTypes = {
  [SURVEY_REPORT_TYPE.GENERAL]: { label: 'General', color: 'default' },
  [SURVEY_REPORT_TYPE.INVESTMENT_HEALTHCHECK]: {
    label: 'Health Check (FHC)',
    color: 'green',
  },
  [SURVEY_REPORT_TYPE.HOT_NEW]: { label: 'Hot New', color: 'orange' },
  [SURVEY_REPORT_TYPE.SETUP_RISK_PROFILE]: {
    label: 'Risk Profile',
    color: 'blue',
  },
};

export const surveyReportTypeOptions = Object.entries(
  surveyReportTypes
).map(([value, { label }]) => ({ value, label }));

export const SURVEY_REPORT_STATUS_DONE = 1003;

export const surveyReportStatuses = {
  1001: { label: 'New', color: 'default' },
  1002: { label: 'Processing', color: 'processing' },
  [SURVEY_REPORT_STATUS_DONE]: { label: 'Done', color: 'success' },
};

// Only generated investment health check reports have a result page on
// stag.vn; other types store their result elsewhere (risk_profiles for 1004).
export const getReportResultUrl = report =>
  report?.type === SURVEY_REPORT_TYPE.INVESTMENT_HEALTHCHECK &&
  report?.status === SURVEY_REPORT_STATUS_DONE &&
  report?.code
    ? `https://stag.vn/suc-khoe-tai-chinh/${report.code}`
    : null;
